<template>
  <div class="grid-container mt-6 md:mt-14">
    <Head title="Ofertas de Trabajo" />
    <header class="flex flex-col gap-2">
      <h1 class="headline-md text-primary font-bold md:display-sm">Ofertas de Trabajo</h1>
      <p class="title-lg text-secondary">
        Gestiona las publicaciones de ofertas de trabajo de tu empresa
      </p>
    </header>
    <hr class="my-2" />
    <div class="my-4">
      <div v-if="jobs.length > 0" class="flex flex-col gap-2" style="position:relative">
        <div  v-for="(offer, key) in jobs" :key="key" class="mt-4">
          <span @click="deleteJob(offer.id)" class="close">x</span>
          <Link
            :href="$route('company.jobs.show', offer.id)"
            class="w-full"           
            :key="key.id"
          >
            <OfferCard :offer="{ ...offer }" outlined show-chips :offer_id="offer.id" />
          </Link>

          <div v-if="auth_token" class="flex flex-col items-end -mt-12">
            <a :href="'https://bolsadetrabajo.sv/cvexcel/?jpid='+ offer.id +'&cid='+ company_id +'&auth='+ auth_token['auth_token'] " 
                target="_blank" rel="external noopener">
              <Button class="btn-filled bg-tertiary-container text-on-tertiary-container fill-currentColor" icon="download">
                Excel
              </Button>
            </a>
          </div>
        </div>        
      </div>      
      <div v-else class="flex flex-col gap-2 justify-center items-center">
        <Illustration name="lost" class="rounded-2xl bg-neutral99 w-full max-h-36 p-2" />
        <p class="label-lg text-center text-on-surface-variant">
          Parece que no has publicado ninguna oferta...
        </p>
        <Link :href="$route('company.jobs.create')" class="btn-outlined">Crear nueva oferta</Link>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import ListItemWithDivider from '@/Components/ListItemWithDivider'
import OfferCard from '@/Components/OfferCard'
import Button from '@/Components/Button'

export default {
  name: 'CompanyJobsIndex',
  layout: Layout,
  components: {
    Head,
    Link,
    ListItemWithDivider,
    OfferCard,
    Button,
    Illustration: () => import('@/Components/Illustration'),
  },
  props: {
    jobs: Array,
    company_id:Number,
    auth_token:Object,
  },
  methods: {
    deleteJob(key) {
      this.$swal.fire({
        title: 'Confirmación:',
        text: '¿Estás seguro que quieres borrar ese dato?',
        showConfirmButton: true,
        showCancelButton: true,
      })
      .then(result => {
        if (result.isConfirmed) {
          this.$inertia.post(this.$route(`company.job.delete`), { id: key }, {
            preserveState: true,
            onError: errors => {
              this.$swal.fire({
                title: '¡Error!',
                text: 'Parece que ha ocurrido un error. Revisa los datos e intenta de nuevo.',
              })
            },
            onSuccess: () => {
              this.$swal.fire({
                title: 'Registro Elimniado!',
                text: 'Tus datos se guardaron con éxito',
              })
            },
          })
        }
      })
    }
  }
}
</script>

<style>
.close{
  background: #212121;
    color: white;
    width: 30px;
    padding: 0.1em;
    position: absolute;
    cursor: pointer;
    /* float: left; */
    /* margin-right: 20px; */
    text-align: center;
    /* right: 30px; */
    margin-top: -15px;
    margin-left: -10px;
    border: 2px solid #212121;
    border-radius: 50%;
}
</style>
